import { RootState } from '../store';

export const selectIsDisclaimerVisible = (state: RootState): boolean =>
  state.authDisclaimer.mountedCount > 0;
